
import { useState } from 'react';
import { useNavigate, Navigate } from 'react-router-dom';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Label } from '@/components/ui/label';
import { InputOTP, InputOTPGroup, InputOTPSlot } from '@/components/ui/input-otp';
import { toast } from 'sonner';
import { useSuperAdminAuth } from '@/contexts/SuperAdminAuthContext';
import Navbar from '@/components/layout/Navbar';
import Footer from '@/components/layout/Footer';

const SuperAdminLogin = () => {
  const [pin, setPin] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const { user, login } = useSuperAdminAuth();
  const navigate = useNavigate();

  // Redirect if already logged in
  if (user) {
    return <Navigate to="/super-admin" replace />;
  }

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    
    if (pin.length !== 4) {
      toast.error('يجب أن يكون الرقم السري 4 أرقام');
      return;
    }

    setIsLoading(true);

    try {
      const result = await login(pin);
      
      if (result.error) {
        toast.error('رقم سري غير صحيح');
      } else {
        toast.success('تم تسجيل الدخول بنجاح');
        navigate('/super-admin');
      }
    } catch (error) {
      toast.error('فشل تسجيل الدخول. حاول مرة أخرى.');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex flex-col bg-white">
      <Navbar />
      
      <div className="flex-grow flex items-center justify-center pt-16 pb-8 px-4 sm:pt-20 sm:pb-12">
        <Card className="w-full max-w-md">
          <CardHeader className="px-4 pt-6 pb-4 sm:px-6">
            <CardTitle className="text-xl sm:text-2xl text-center text-autocare-blue">دخول المدير العام</CardTitle>
            <CardDescription className="text-center text-sm sm:text-base">
              أدخل الرقم السري المكون من 4 أرقام للوصول إلى لوحة الإدارة العامة
            </CardDescription>
          </CardHeader>
          <CardContent className="px-4 pb-6 sm:px-6">
            <form onSubmit={handleSubmit} className="space-y-6">
              <div className="space-y-2">
                <Label htmlFor="pin" className="text-center block">الرقم السري (4 أرقام)</Label>
                <div className="flex justify-center">
                  <InputOTP
                    maxLength={4}
                    value={pin}
                    onChange={(value) => setPin(value)}
                  >
                    <InputOTPGroup>
                      <InputOTPSlot index={0} />
                      <InputOTPSlot index={1} />
                      <InputOTPSlot index={2} />
                      <InputOTPSlot index={3} />
                    </InputOTPGroup>
                  </InputOTP>
                </div>
              </div>
              
              <Button
                type="submit"
                className="w-full"
                disabled={isLoading || pin.length !== 4}
              >
                {isLoading ? 'جاري تسجيل الدخول...' : 'تسجيل الدخول'}
              </Button>
            </form>
          </CardContent>
        </Card>
      </div>
      
      <Footer />
    </div>
  );
};

export default SuperAdminLogin;
